import { takeLatest } from "redux-saga/effects";
import { homePageData } from "./containers/Home/redux/slice";
import { handleDecryptUserDetails, handleOpcoRequest, handleStyleOfBusiness, OPCO_REQUEST, STYLE_OF_BUSINESS_REQUEST } from './containers/Home/redux/saga-handler'; 

export function* watcherSaga() {
  yield takeLatest(homePageData.type, handleDecryptUserDetails);
  yield takeLatest(OPCO_REQUEST, handleOpcoRequest);
  yield takeLatest(STYLE_OF_BUSINESS_REQUEST, handleStyleOfBusiness);
};
